/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React, {useMemo} from 'react';

import {batch, connect, useSelector} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {GetRequest} from '@/api/request';
import {openFileUpdaterOffline} from '@/businesses/systemUpdateBusiness';
import ListExplorer from '@/components/explorer/explorerView/listExplorer/ListExplorer';
import ToggleButton from '@/components/togglebutton/ToggleButton';
import {ALERT_TYPE} from '@/constants/enums';
import {EXPORT_IMPORT} from '@/constants/messages';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventLicenseService} from '@/constants/pubSubEnum';
import UseUsb from '@/hooks/useUsb';
import {consoleLog, consoleError, consoleDebug} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import './UsbFileList.less';

// TODO: temporary solution to be able use the custom hook that handles the usb list api control
const withUsbList = (Component) => {
  function useUsbList(props) {
    const usbProperties = useSelector((store) => store.setupStore.usbProperties);
    const {usbList, RefreshUsbList} = UseUsb();
    const AvailableUsbList = useMemo(() => (usbList.length !== 0 ? usbList : usbProperties), [usbList, usbProperties]);
    return (
      <Component
        RefreshingUsbList={RefreshUsbList}
        AvailableUsbList={AvailableUsbList}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }

  return useUsbList;
};

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  selectedFile: store.setupStore.selectedFileUpdate,
  usbProperties: store.setupStore.usbProperties,
  usbOpenFor: store.setupStore.usbOpenFor,
  alertShow: store.setupStore.alertShow,
  alertText: store.setupStore.alertText,
  alertStyle: store.setupStore.alertStyle,
}))
class USBFileList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileListAll: undefined,
      fileList: undefined,
      dataState: ListExplorer.state.NO_DATA,
      /**
       * indicate current selected usb drive index
       */
      currentDrive: 0,
      updateProps: undefined,
    };
    this._bus = eventBusObject();
    // this.successSendPath = this.successSendPath.bind(this);
    // this.errorSendPath = this.errorSendPath.bind(this);
    // this.failedSendPath = this.failedSendPath.bind(this);
    // this.successCancelUpdate = this.successCancelUpdate.bind(this);
    // this.successPostInstallUpdate = this.successPostInstallUpdate.bind(this);
    // this.errorPostInstallUpdate = this.errorPostInstallUpdate.bind(this);
    // this.failedPostInstallUpdate = this.failedPostInstallUpdate.bind(this);
  }

  componentDidMount() {
    this._ismounted = true;
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.SELECT_FILE));
    this.setTopMenuProperties(true, APPDATA.SELECT_FILE);
    this.SetFileLoaderDisplay();
    this.getFileList();
  }

  componentWillUnmount() {
    this._ismounted = false;
    batch(() => {
      this.props.dispatch(setupActions.selectedFileUpdate(undefined));
      this.props.dispatch(setupActions.usbProperties(undefined));
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    consoleLog('componentWillReceiveProps', nextProps);
    const {alertShow, alertText, alertStyle} = nextProps;
    if (
      alertShow &&
      alertText === EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND &&
      alertStyle === APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER
    )
      this.goToInfoPage();
    this.getFileList();
  }

  openSelectedFile() {
    const {usbOpenFor, dispatch} = this.props;
    switch (usbOpenFor) {
      case APPDATA.USB_OPEN_FOR.IMPORT_UPDATE:
        dispatch(openFileUpdaterOffline());
        // this.sendPathUpdateFile(this.props.selectedFile.Preview);
        break;

      case APPDATA.USB_OPEN_FOR.IMPORT_LICENSE: {
        const param = {
          LicenseFile: this.props.selectedFile.Preview,
        };
        this._bus.publish(EventLicenseService.ActivateLicenseManual, param);
        break;
      }
      default:
        break;
    }
  }

  setTopMenuProperties = (disabledMainButton, titleMenu) => {
    const topButtonProperties = {
      id: APPDATA.OPEN,
      label: APPDATA.OPEN,
      onClick: this.onClickTopMenu,
      disabled: disabledMainButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.onClickTopMenu,
    };
    const titleMenuProperties = titleMenu;

    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  onClickTopMenu = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.OPEN:
        this.openSelectedFile();
        break;
      case APPDATA.BACK:
        this.goToInfoPage();
        break;
      default:
        break;
    }
  };

  // eslint-disable-next-line class-methods-use-this
  generateBottomMenu = () => <div className="usbFileListBottom center footer" />;

  //-----------------------------------------------------------------------
  // ------------------------- Get File List ------------------------------
  SetFileLoaderDisplay() {
    this.setState({dataState: ListExplorer.state.WAITING_DATA});
  }

  successGetFileList(response) {
    consoleDebug('successGetFileList', response);
    const {data} = response;
    const {usbOpenFor} = this.props;
    const {currentDrive} = this.state;
    let fileListOrigin = [];
    const fileListAll = [];
    let fileList = [];

    // TODO: this logic can be optimize / minimize
    for (let usb = 0; usb < data.details.length; usb++) {
      switch (usbOpenFor) {
        case APPDATA.USB_OPEN_FOR.IMPORT_UPDATE:
          fileListOrigin = data.details[usb].Software;
          break;
        case APPDATA.USB_OPEN_FOR.IMPORT_LICENSE:
          fileListOrigin = data.details[usb].License;
          break;
        default:
          break;
      }
      fileList = [];
      for (let id = 0; id < fileListOrigin.length; id++) {
        const tempFileList = {
          Id: id,
          Name: fileListOrigin[id].Filename,
          Preview: fileListOrigin[id].FilePath,
        };
        if (this.props.selectedFile !== undefined && this.props.selectedFile.Preview === tempFileList.Preview)
          tempFileList.Active = true;
        fileList[id] = tempFileList;
      }
      fileListAll[usb] = fileList;
    }
    consoleLog('fileList', fileListAll, this.props, this.state);
    if (fileListAll[currentDrive] === undefined) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND,
          alertStyle: ALERT_TYPE.ALERT_DANGER,
        }),
      );
      this.goToInfoPage();
    }

    if (this._ismounted) {
      this.setState({
        fileListAll,
        fileList: fileListAll[currentDrive],
        dataState: data.details.length === 0 ? ListExplorer.state.NO_DATA : ListExplorer.state.AVAILABLE_DATA,
      });
    }
  }

  failedsGetFileList = (error) => {
    consoleError('FAILED', error);
    if (this._ismounted) {
      this.setState({dataState: ListExplorer.state.NO_DATA});
    }
  };

  getFileList = () => {
    const {AvailableUsbList} = this.props;
    if (AvailableUsbList === undefined) {
      consoleLog('None of Usb device Found');
      this.goToInfoPage();
    }

    switch (this.props.usbOpenFor) {
      case APPDATA.USB_OPEN_FOR.IMPORT_UPDATE:
        GetRequest(APPDATA.API.GET_SOFTWARE_UPDATE_FILE_LIST)
          .then((response) => this.successGetFileList(response))
          .catch(this.failedsGetFileList);
        break;

      case APPDATA.USB_OPEN_FOR.IMPORT_LICENSE:
        GetRequest(APPDATA.API.GET_LICENSE_FILE_LIST)
          .then((response) => this.successGetFileList(response))
          .catch(this.failedsGetFileList);
        break;

      default:
        this.goToInfoPage();
        break;
    }
  };
  // --------------------- End Get File List ------------------------------

  // --------------------- send path file ---------------------------------

  // sendPathUpdateFile = async () => {
  // this.props.dispatch(
  //   loadingActions.updateLoading({
  //     showLoading: true,
  //     loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.CHEKING_FILE,
  //     loadingClickEvent: undefined,
  //   }),
  // );
  // const param = {
  //   file: 'PC.Server.latest.tar.gz',
  //   filePath: path,
  // };
  // const passingVariabel = param;
  // Post(
  //   APPDATA.API.POST_UPDATE_OFFLINE_SOFTWARE,
  //   param,
  //   this.successSendPath,
  //   passingVariabel,
  //   this.errorSendPath,
  //   this.failedSendPath,
  // );
  // };

  // successSendPath = (response, passingVariabel) => {
  //   consoleLog('successSendPath', {response, passingVariabel});
  //   this.props.dispatch(loadingActions.showLoading(false));
  //   switch (response.data.type) {
  //     case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED:
  //       if (this._ismounted) {
  //         this.setState(
  //           {
  //             updateProps: response.data.updateProps,
  //           },
  //           () => {
  //             this.downgradeModal();
  //           },
  //         );
  //       }
  //       break;
  //     case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION:
  //       if (this._ismounted) {
  //         this.setState(
  //           {
  //             updateProps: response.data.updateProps,
  //           },
  //           () => {
  //             this.reinstallModal();
  //           },
  //         );
  //       }
  //       break;
  //     default:
  //       if (this._ismounted) {
  //         this.setState(
  //           {
  //             updateProps: response.data.updateProps,
  //           },
  //           () => {
  //             // change this behavior
  //             this.needRestartModal();
  //           },
  //         );
  //       }
  //       break;
  //   }
  // };

  // failedSendPath = (response, passingVariabel) => {
  //   this.props.dispatch(loadingActions.showLoading(false));
  //   consoleLog('failedSendPath', {response, passingVariabel});
  // };

  // errorSendPath = (error, passingVariabel) => {
  //   this.props.dispatch(loadingActions.showLoading(false));
  //   consoleLog('errorSendPath', {error, passingVariabel});
  //   switch (error.response.data.type) {
  //     // case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED:
  //     // case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION:
  //     //     this.props.dispatch(
  //     //         setupActions.showAlert({
  //     //             alertShow: true,
  //     //             alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED],
  //     //             alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
  //     //         })
  //     //     );
  //     //     break;
  //     case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED:
  //       this.props.dispatch(
  //         setupActions.showAlert({
  //           alertShow: true,
  //           alertText:
  //             APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.CORRUPTED],
  //           alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
  //         }),
  //       );
  //       break;
  //     case APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED:
  //       this.props.dispatch(
  //         setupActions.showAlert({
  //           alertShow: true,
  //           alertText:
  //             APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[
  //               APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.LICENSE_EXPIRED
  //             ],
  //           alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
  //         }),
  //       );
  //       break;
  //     default:
  //       break;
  //   }
  // };

  // needRestartModal = () => {
  //   const popUpButton = [
  //     {
  //       id: APPDATA.RESTART,
  //       isPrimaryButton: true,
  //       onClick: this.onClickRestartModal,
  //       label: APPDATA.RESTART,
  //     },
  //     {
  //       id: APPDATA.LATER,
  //       isPrimaryButton: false,
  //       onClick: this.onClickRestartModal,
  //       label: APPDATA.LATER,
  //     },
  //   ];
  //   this.props.dispatch(
  //     modalActions.showPopUp({
  //       popUpTitle: APPDATA.MESSAGES.SOFTWARE_UPDATE.MODAL_NEED_RESTART.TITLE,
  //       popUpText: APPDATA.MESSAGES.SOFTWARE_UPDATE.MODAL_NEED_RESTART.TEXT,
  //       popUpButton,
  //       popUpClose: this.onClosePopUp,
  //     }),
  //   );
  // };

  // downgradeModal = () => {
  //   const popUpButton = [
  //     {
  //       id: APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED].BUTTON,
  //       isPrimaryButton: true,
  //       onClick: this.onClickDowngradeOrReinstallModal,
  //       label:
  //         APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED].BUTTON,
  //     },
  //     {
  //       id: APPDATA.CANCEL,
  //       isPrimaryButton: false,
  //       onClick: this.onClickDowngradeOrReinstallModal,
  //       label: APPDATA.CANCEL,
  //     },
  //   ];
  //   this.props.dispatch(
  //     modalActions.showPopUp({
  //       popUpTitle:
  //         APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED].TITLE,
  //       popUpText:
  //         APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED].TEXT,
  //       popUpButton,
  //       popUpClose: this.onClosePopUp,
  //     }),
  //   );
  // };

  // reinstallModal = () => {
  //   const popUpButton = [
  //     {
  //       id: APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION]
  //         .BUTTON,
  //       isPrimaryButton: true,
  //       onClick: this.onClickDowngradeOrReinstallModal,
  //       label:
  //         APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION]
  //           .BUTTON,
  //     },
  //     {
  //       id: APPDATA.CANCEL,
  //       isPrimaryButton: false,
  //       onClick: this.onClickDowngradeOrReinstallModal,
  //       label: APPDATA.CANCEL,
  //     },
  //   ];
  //   this.props.dispatch(
  //     modalActions.showPopUp({
  //       popUpTitle:
  //         APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION].TITLE,
  //       popUpText:
  //         APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION].TEXT,
  //       popUpButton,
  //       popUpClose: this.onClosePopUp,
  //     }),
  //   );
  // };

  // onClosePopUp = () => {
  //   this.props.dispatch(modalActions.hidePopUp());
  //   Post(APPDATA.API.CANCEL_UPDATE, {}, this.successCancelUpdate);
  // };

  // onClickDowngradeOrReinstallModal = (e) => {
  //   switch (e.currentTarget.id) {
  //     case APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED].BUTTON:
  //     case APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_OFFLINE[APPDATA.ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION]
  //       .BUTTON:
  //       this.needRestartModal();
  //       break;
  //     case APPDATA.CANCEL:
  //       this.props.dispatch(modalActions.hidePopUp());
  //       Post(APPDATA.API.CANCEL_UPDATE, {}, this.successCancelUpdate);
  //       break;
  //     default:
  //       break;
  //   }
  // };

  // onClickRestartModal = (e) => {
  //   const {updateProps} = this.state;
  //   const tempUpdateProps = updateProps;
  //   let param = {};
  //   let passingVariabel = param;
  //   switch (e.currentTarget.id) {
  //     case APPDATA.RESTART:
  //       tempUpdateProps.IsRestartRequired = true;
  //       param = tempUpdateProps;
  //       passingVariabel = param;
  //       Post(
  //         APPDATA.API.POST_INSTALL_OFFLINE_UPDATE_SOFTWARE,
  //         param,
  //         this.successPostInstallUpdate,
  //         passingVariabel,
  //         this.errorPostInstallUpdate,
  //         this.failedPostInstallUpdate,
  //       );
  //       break;
  //     case APPDATA.LATER:
  //       tempUpdateProps.IsRestartRequired = false;
  //       param = tempUpdateProps;
  //       passingVariabel = param;
  //       Post(
  //         APPDATA.API.POST_INSTALL_OFFLINE_UPDATE_SOFTWARE,
  //         param,
  //         this.successPostInstallUpdate,
  //         passingVariabel,
  //         this.errorPostInstallUpdate,
  //         this.failedPostInstallUpdate,
  //       );
  //       break;
  //     default:
  //       break;
  //   }
  //   this.props.dispatch(modalActions.hidePopUp());
  // };

  // successPostInstallUpdate = (response, passingVariabel) => {
  //   consoleLog('successPostInstallUpdate', {response, passingVariabel});
  //   if (response.data) {
  //     if (passingVariabel.IsRestartRequired) {
  //       this.props.dispatch(
  //         loadingActions.updateLoading({
  //           showLoading: true,
  //           loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.SHUTTING_DOWN,
  //           loadingClickEvent: undefined,
  //         }),
  //       );
  //     } else {
  //       this.props.dispatch(
  //         setupActions.showAlert({
  //           alertShow: true,
  //           alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_WHEN_RESTART,
  //           alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO,
  //         }),
  //       );
  //     }
  //   } else {
  //     this.props.dispatch(
  //       setupActions.showAlert({
  //         alertShow: true,
  //         alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.FAILED_UPDATE,
  //         alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
  //       }),
  //     );
  //   }
  // };

  // // eslint-disable-next-line class-methods-use-this
  // failedPostInstallUpdate = (response, passingVariabel) => {
  //   consoleLog('failedPostInstallUpdate', {response, passingVariabel});
  // };

  // // eslint-disable-next-line class-methods-use-this
  // errorPostInstallUpdate = (error, passingVariabel) => {
  //   consoleLog('errorPostInstallUpdate', {error, response: error.response, passingVariabel});
  // };

  // // eslint-disable-next-line class-methods-use-this
  // successCancelUpdate = () => {};

  //---------------------------------------------------------------------------------------
  getSelectedList = (selectedFile) => {
    const {usbProperties} = this.props;
    const label = usbProperties === undefined ? '' : usbProperties.Label;
    this.setTopMenuProperties(false, label);
    this.props.dispatch(setupActions.selectedFileUpdate(selectedFile));
  };

  /**
   * @param {*} e
   * @param {*} v
   */
  onClickChangeUSB = (e) => {
    const {AvailableUsbList, RefreshingUsbList} = this.props;
    const selectedUsb = AvailableUsbList.find((usb) => usb.Path === e.currentTarget.id);
    this.setState(
      {
        currentDrive: AvailableUsbList.indexOf(selectedUsb),
      },
      () => {
        this.SetFileLoaderDisplay();
        RefreshingUsbList();
      },
    );
  };

  // eslint-disable-next-line class-methods-use-this
  goToInfoPage() {
    window.location.href = APPDATA.INFO_AND_SUPPORT_ADDRESS;
  }

  render() {
    const {fontSize, AvailableUsbList} = this.props;
    const style = {
      constraint: {
        fontSize,
      },
    };
    const {currentDrive} = this.state;
    const usbDriveButtonProp = AvailableUsbList
      ? AvailableUsbList.map((availableUsb, index) => ({
          label: availableUsb.Label,
          value: index,
          id: availableUsb.Path,
        }))
      : [];

    let divUsbDriveBottonClassName = 'col-md-12';
    switch (usbDriveButtonProp.length) {
      case 1:
        divUsbDriveBottonClassName = 'col-md-3';
        break;
      case 2:
        divUsbDriveBottonClassName = 'col-md-6';
        break;
      case 3:
        divUsbDriveBottonClassName = 'col-md-9';
        break;
      default:
        divUsbDriveBottonClassName = 'col-md-12';
        break;
    }

    return (
      <div style={style.constraint}>
        <div className="rowHeightToggleButton middleAlign ">
          {/* //TODO: it may a good option to break down this part into separate component (ex. USB Drive Button Selector) */}
          <div className={`${divUsbDriveBottonClassName} toggleProfileType`}>
            <ToggleButton
              buttonProp={usbDriveButtonProp}
              defaultValue={currentDrive}
              value={currentDrive}
              onClick={this.onClickChangeUSB}
            />
          </div>
        </div>
        <ListExplorer
          listContent={this.state.fileList} // {FileListDummy()}
          callBackSelectedList={this.getSelectedList}
          dataState={this.state.dataState}
          isFullView // untuk scrollbar
          className=" usbListView"
          height={360}
        />
        {this.generateBottomMenu()}
      </div>
    );
  }
}
export default withUsbList(USBFileList);
